import axios from "axios";
import React, { useEffect, useState } from "react";
import { hostname } from "src/HostName";

const useGetPaymentGateway = () => {
  const [stateObjData, setStateObjData] = useState({
    loading: true,
    gateWayList: [],
    error: "",
  });
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${hostname}get/gateway`);
        setStateObjData((pre) => ({
          ...pre,
          gateWayList: data.data || [],
        }));
      } catch (error) {
        setStateObjData((pre) => ({
          ...pre,
          error: "error",
        }));
      }
      setStateObjData((pre) => ({
        ...pre,
        loading: false,
      }));
    })();
  }, []);
  return stateObjData;
};

export default useGetPaymentGateway;
